module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-slider"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.intro
    }
  }), _c('div', {
    staticClass: "custom-home-slider__container"
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "loop": true,
      "paginationEnabled": false,
      "navigationEnabled": true,
      "navigationNextLabel": _vm.arrowRight,
      "navigationPrevLabel": _vm.arrowLeft
    }
  }, _vm._l((_vm.props.slide), function(content, i) {
    return _c('slide', {
      key: i
    }, [_c('div', {
      staticClass: "custom-home-slider__content-container"
    }, [_c('div', {
      staticClass: "custom-home-slider__img"
    }, [_c('img', {
      attrs: {
        "src": content.img,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "custom-home-slider__text",
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    })])])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc44480","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-slider/custom-home-slider.pug
// module id = 586
// module chunks = 1